import { lazy } from 'react';

export const LockScreenLazy = lazy(() => import('./LockScreen'));
